import React from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import { YouthProtectionSign } from './YouthProtectionSign';
import { Fonts } from '../../../../play-core/styles/Fonts';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const translationMap = {
  YELLOW: 'global.youthProtectionYellow',
  RED: 'global.youthProtectionRed'
};
export const YouthProtectionInfo = ({
  youthProtectionColor
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsxs(YouthProtectionLayout, {
    children: [/*#__PURE__*/_jsx(YouthProtectionSign, {
      youthProtectionColor: youthProtectionColor
    }), /*#__PURE__*/_jsx(YouthProtectionMessage, {
      children: t(translationMap[youthProtectionColor])
    })]
  });
};
const YouthProtectionMessage = styled.span.withConfig({
  displayName: "YouthProtectionInfo__YouthProtectionMessage",
  componentId: "sc-1qhdznu-0"
})(["", ";line-height:20px;"], Fonts.light(16));
const YouthProtectionLayout = styled.span.withConfig({
  displayName: "YouthProtectionInfo__YouthProtectionLayout",
  componentId: "sc-1qhdznu-1"
})(["display:grid;grid-gap:8px;grid-auto-flow:column;grid-auto-columns:auto 1fr;grid-auto-rows:1fr;align-items:center;"]);